import api from "../../APIIntercepter";

async function getStaffsAPI() {
  const res = await api.get("/user/admin/staff");
  return res.data;
}

async function createStaffAPI(params) {
  const res = await api.post("/user/admin/staff/register", params);
  return res.data;
}

async function updateStaffAPI(params) {
  const res = await api.put("/user/admin/staff/update", params);
  return res.data;
}

async function deleteStaffAPI(staffId) {
  const res = await api.delete("/user/admin/staff/remove/" + staffId);
  return res.data;
}

async function changeStaffPasswordAPI(params) {
  const res = await api.put("/user/admin/staff/changePassword", params);
  return res.data;
}

export {
  getStaffsAPI,
  createStaffAPI,
  updateStaffAPI,
  deleteStaffAPI,
  changeStaffPasswordAPI,
};
